<template>
    <transition enter-active-class="animated faster zoomIn">
        <div class="desgin_wrap" :class="{ fullscreen: fullshow && $root.system == 'ios' }">
            <title-bar :title="image.name" type="back" :show="!fullshow" :to="backTo">
                <div slot="right" @click="showShare(true)" v-if="$root.isWebview">分享</div>
            </title-bar>
            <div
                v-show="guideDesc"
                class="guide_slide"
                :class="{ hide: !guide }"
                @touchstart="hideGuide"
            ></div>
            <v-touch @tap="fullShow" class="image_box">
                <div class="swiper-container" style="height:100%">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in imgList" :key="index">
                            <div class="imgwrapper" :class="{ scroll: item.scroll }">
                                <!-- <p style="position:relative;z-index:10000;color:red">{{item.height}}</p> -->
                                <img
                                    :src="item.src"
                                    :class="{ center: item.height < $root.device.size.height }"
                                    :height="item.height"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </v-touch>
            <div v-if="loadFailed" class="load-failed">
                load failed
            </div>
            <div class="fn_btns" :class="{ hide: this.fullshow }">
                <router-link class="comment_btn" :to="{ name: 'comment', query: $route.query }">打点评论</router-link>
                <router-link
                    class="play_btn"
                    @click="count('current_play')"
                    :to="{ name: 'proto', query: $route.query }"
                >从当前页面播放</router-link>
            </div>
            <share :show="share" @close="showShare(false)" :image="shareImage" type="design"></share>
        </div>
    </transition>
</template>

<script>
import API from "../../api/api.js"
import titleBar from "@/components/layout/TitleBar"
import share from "@/components/common/Sharing"

export default {
    components: {
        titleBar,
        share
    },
    
    data() {
        return {
            fullshow: false,
            share: false,
            guide: true,
            image: {},
            guideDesc: null,
            loadFailed: false,
            imgList: []
        }
    },
    computed: {
        shareImage() {
            if (Object.values(this.image).length) {
                try {
                    this.image.src = this.image.src.replace("?x-oss-process=image/format,webp", "")
                } catch (e) {}
                return this.image
            }
        },
        projectId() {
            return this.$route.query.project_id
        },
        backTo() {
            let project_id = this.projectId
            return {
                name: "item",
                query: {
                    project_id
                }
            }
        }
    },
    mounted() {
        this.judgeGuide()
        this.iniData()
        try {
            if (window.isWebview) {
                console.log("[解锁屏幕方向]")
                screen.orientation.unlock()
                this.orient()
            }
        }
        catch (e) {
            // alert(e.toString())
        }
    },
    destroyed() {
        if (window.isWebview) {
            this.rmOrient()
        }
    },
    methods: {
        //旋屏相关
        count(param) {
            MtaH5.clickStat(param)
        },
        orient() {
            screen.orientation.addEventListener("change", this.judgeOrient, false)
        },
        rmOrient() {
            screen.orientation.lock("portrait")
            screen.orientation.removeEventListener("change", this.judgeOrient, false)
            console.log("[移除屏幕方向监听事件]")
        },
        judgeOrient() {
            if (!screen.orientation.type.includes("portrait")) {
                this.fullshow = true
                StatusBar.hide()
            } else {
                this.fullshow = false
                StatusBar.show()
            }
        },
        resize() {
            console.log("resize触发了")
            this.imgList = this.setImagesHeight(window.imagesList)
            this.image = this.getImageData(this.imgList)["data"] //重新赋值引用imgList
            this.judgeScroll()
        },
        iniData() {
            if (window.imagesList) {
                this.imgList = this.setImagesHeight(window.imagesList)
                this.iniSwiper()
                this.setPinchZoom()
            } else {
                //如果没有图片列表，先去获取
                this.getImageList()
            }
            window.onresize = this.resize
        },
        getImageData(data) {
            let imageId = this.$route.query.image_id
            let index = 0
            let imageData = {}
            data.forEach((ele, i) => {
                if (ele.id == imageId) {
                    index = i
                    imageData = ele
                }
            })

            return { data: imageData, index: index }
        },
        setPinchZoom() {
            this.$nextTick(() => {
                let imgs = [...document.querySelectorAll(".image_box .imgwrapper")]
                imgs.forEach(ele => {
                    new PinchZoom.default(ele, { draggableUnzoomed: false })
                })
            })
        },
        setImagesHeight(listData) {
            console.log('触发了setImagesHeight函数重新计算高度')
            let data = JSON.parse(JSON.stringify(listData)) //克隆后 image对 imgList 引用会被切断
            
            // let w = this.$root.device.size.width
            // let h = this.$root.device.size.height

            let w = document.body.clientWidth
            let h = document.body.clientHeight

            let res = data.map(ele => {
                console.log(`设备宽度${w},图片宽度${ele.width},图片高度${ele.height}`)
                let height = (Number(w) / Number(ele.width)) * Number(ele.height)
                console.log(`计算出的高度:${height}`)
                ele.height = height
                ele.scroll = false
                return ele
            })
            
            return res
            
        },
        judgeScroll() {
            //是否滚动
            // let h = this.$root.device.size.height
            let h = document.body.clientHeight
            this.image.scroll = false

            if (this.image.height > h) {
                this.image.scroll = true
            } else {
                this.image.scroll = false
            }
        },
        iniSwiper() {
            this.$nextTick(() => {
                let _this = this
                window.swiper = new Swiper(".swiper-container", {
                    onSlideChangeEnd: function(swiper) {
                        let activeData = _this.imgList[swiper.activeIndex]
                        _this.image = activeData
                        _this.judgeScroll()

                        let query = _this.$route.query
                        _this.$router.push({
                            query: {
                                image_id: _this.image["id"],
                                project_id: query.project_id,
                                project_name: query.project_name
                            }
                        })
                    }
                })

                let res = this.getImageData(this.imgList)
                this.image = res.data

                this.judgeScroll()
                let index = res.index
                if (index) {
                    swiper.slideTo(index, 0)
                }
            })
        },
        judgeGuide() {
            this.guideDesc = localStorage.showGuide
        },
        async getImageList() {
            let params = {
                pid: this.projectId,
                team_id: localStorage.teamId
            }
            let res = await lanhuAPI.project.getProjectInfoOrigin(this.projectId)
            if (res) {
                let data = res

                window.imagesList = data.images.map(ele => {
                    return {
                        id: ele.id,
                        name: ele.name,
                        src: window.mtd.handleImg(ele.url, {
                            ali: this.$root.isSupportWebp ? "?x-oss-process=image/format,webp" : "",
                            qiniu: ""
                        }),
                        width: ele.width,
                        height: ele.height
                    }
                })

                this.imgList = this.setImagesHeight(window.imagesList)
                this.iniSwiper()
                this.setPinchZoom()
            }
            else {
                this.loadFailed = true;
            }
        },
        fullShow() {
            this.fullshow = !this.fullshow
            if (window.isWebview) {
                if (this.fullshow) {
                    StatusBar.hide()
                } else {
                    StatusBar.show()
                }
            }
        },
        hideGuide() {
            localStorage.showGuide = ""
            this.guide = false
        },
        showShare(b) {
            if (b == true) {
                localStorage.setItem("bann", "true")
            } else {
                localStorage.setItem("bann", "")
            }
            this.share = b
        }
    }
}
</script>

<style>
.pinch-zoom-container {
    height: 100% !important;
}
</style>

<style lang="scss" scoped>
.desgin_wrap {
    width: 100%;
    height: 100%;
    // background: #222222;
    position: relative;

    &.fullscreen {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
    }
    .load-failed {
        position: absolute;
        top: 50%;
        display: block;
        width: 100%;
        text-align: center;
    }
    .image_box {
        height: 100%;
    }
    .guide_slide {
        z-index: 1111;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8) url("~@/assets/imgs/guide_slide.png") center center / 70% no-repeat;
        transition: all ease 300ms;
        &.hide {
            opacity: 0;
            z-index: 0;
        }
    }
    .imgwrapper {
        text-align: center;
        width: 100%;
        height: 100%;
        // position: absolute;
        // top: 0;
        // bottom: 0;
        // overflow-y: auto;
        // display:grid;
        // align-items: center;
        &.scroll {
            overflow-y: auto;
            //height:auto !important;
        }
        img {
            width: 100%;
            display: block;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
            &.center {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    .fn_btns {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 11;
        width: 100%;
        padding: 0.5rem 1rem;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 0.5rem);
        padding-bottom: calc(env(safe-area-inset-bottom) + 0.5rem);
        box-sizing: border-box;
        // background: rgba(255, 255, 255, 0.9);
        background: white;
        height: 2rem;
        transition: all ease 300ms;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

        &.hide {
            bottom: -3rem;
        }
        .comment_btn,
        .play_btn {
            font-size: 0.7rem;
            color: rgba(40, 120, 255, 1);
            line-height: 1rem;
        }
        .comment_btn {
            float: left;
            padding-left: 1rem;
            background: url("~@/assets/imgs/comment_icon.png") left center / 0.8rem no-repeat;
        }
        .play_btn {
            padding-left: 0.8rem;
            float: right;
            background: url("~@/assets/imgs/play_icon.png") left center / 0.65rem no-repeat;
        }
    }
}
</style>
